export interface CampaignInterface {
  id: string;
  name: string;
  description: string;
  status: CampaignTypeStatus;
  data: CampaignData;
  groups: {
    id: string;
    name: string;
  }[];
}

export interface CampaignData {
  body: string;
  title: string;
  footer: string;
  header: string;
  subject: string;
}

export interface PostCampaignInterface {
  name: string;
  description: string;
  data: CampaignData;
  groupIds?: string[];
}

export enum CampaignTypeStatus {
  Created = 'created',
  Sent = 'sent',
  Failed = 'failed',
  Bounced = 'bounced',
  Delivered = 'delivered',
  Opened = 'opened',
  Clicked = 'clicked',
  Dropped = 'dropped',
  Spam = 'spam',
  Unsubscribed = 'unsubscribed'
}
